import { render, staticRenderFns } from "./loan_saldo.vue?vue&type=template&id=7d698876"
import script from "./loan_saldo.vue?vue&type=script&lang=js"
export * from "./loan_saldo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports